import { get, post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const loadGlobalParams = () => get(`${url}/parameters/globalParams`);

const saveGlobalParams = (name, value) => {
  return post(`${url}/parameters/save-global-params`, { name: name, value: value });
};

const exp = {
  loadGlobalParams,
  saveGlobalParams
};
export default exp;
